'use strict';

module.exports = function isIe9(ua) {
  ua = ua || navigator.userAgent;
  return ua.indexOf('MSIE 9') !== -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/@braintree/browser-detection/is-ie9.js
// module id = 155
// module chunks = 0